import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.StickyMenu = class StickyMenu extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-sticky-menu';
    }

    constructor(element) {
        super(element);
    }

    setVars() {

    }

    render() {
    }

}

$(function () {
   var cwStickyMenu = new Snappy.Component.StickyMenu();


    /* Smooth Scrolling */
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 75
        }, 500);
    });


    /**********
    STICKY MENU
    **********/
    var stickyMenu = $('#sticky-menu');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 125) {
            stickyMenu.addClass('fixed-nav');
        } else {
            stickyMenu.removeClass('fixed-nav');
        }
    });

    $(window).on('scroll', function () {
        $('.tab-content').each(function () {
            if ($(window).scrollTop() >= $(this).position().top - 100) {
                var id = $(this).attr('id');
                $('.subMenu li a').removeClass('active');
                $('.subMenu li a[href="#' + id + '"]').addClass('active');
            }
        });
    });

});



// WEBPACK FOOTER //
// ./components/sticky-menu/scripts/sticky-menu.js